import { CartItem } from '../../features/cart/storage/cart.types'
import { Product } from '../../features/products/storage'
import { AdobeAnalytics } from './AdobeAnalytics'

export const trackAddToCart = (product: Product) => {
  //Analytics
  AdobeAnalytics.getInstance().trackEvent('add-to-cart', {
    product: [
      {
        productName: product.name,
        productCategory: product.category,
        productSubCategory: product.subCategory,
        productId: product.productId,
      },
    ],
  })
}

export const trackSearch = (text: string, results: number) => {
  //Analytics
  AdobeAnalytics.getInstance().trackEvent('product-search', {
    search: {
      searchTerm: text,
      searchCount: results,
    },
  })
}

export const trackProductView = (item: Product) => {
  //Analytics
  AdobeAnalytics.getInstance().trackEvent('product-views', {
    product: [
      {
        productName: item.name,
        productCategory: item.category,
        productSubCategory: item.subCategory,
        stock: item.lifeCycleState,
        productId: item.productId,
      },
    ],
  })
}

export const trackCartView = (items: CartItem[]) => {
  //Analytics
  AdobeAnalytics.getInstance().trackEvent('cart-views', {
    product: items.map((item) => ({
      productName: item.name,
      // productCategory: item.category,
      productId: item.productId,
      quantity: item.quantity,
    })),
  })
}

export const trackCheckoutSuccess = (
  items: CartItem[],
  orderDetails: { orderId: string; orderType: string },
) => {
  AdobeAnalytics.getInstance().trackEvent('checkout-success', {
    product: items.map((item) => ({
      productName: item.name,
      productCategory: item.category,
      productId: item.productId,
      quantity: item.quantity,
      price: item.editedPriceExcGst ?? item.discountedPriceExcGst,
    })),
    orderDetails: orderDetails,
  })
}

export function initializeClickTracking() {
  document.addEventListener('click', (event: MouseEvent) => {
    // Find the nearest ancestor with the data-testid attribute
    const targetElement = event.target as HTMLElement
    const elementWithTestId = targetElement.closest('[data-testid]') as HTMLElement

    if (elementWithTestId) {
      const testId = elementWithTestId.getAttribute('data-testid')

      if (testId) {
        // Track the click event using AdobeAnalytics
        AdobeAnalytics.getInstance().trackEvent('click-event', {
          clickEvent: {
            elementId: testId,
          },
        })
      }
    }
  })
}
